import _ from 'underscore';
// var googleMaps = window.google.maps;

const DEFAULT_CONFIG = googleMaps => ({
  zoom: 14,
  disableDefaultUI: true,
  disableDoubleClickZoom: false,
  mapTypeControl: false,
  zoomControl: true,
  zoomControlOptions: {
    position: googleMaps.ControlPosition.LEFT_BOTTOM
  },
  fullscreenControlOptions: {
    position: googleMaps.ControlPosition.RIGHT_BOTTOM
  },
  minZoom: 5,
  draggable: true,
  scrollwheel: true
});

var MapsAPI = function(mapId, options) {
  this.options = options || {};
  this.markers = {};
  this.circles = {};
  this.mapId = mapId;
  this.googleMaps = window.google.maps;

  this.map = new this.googleMaps.Map(
    document.getElementById(mapId),
    _.defaults(this.options, DEFAULT_CONFIG(this.googleMaps))
  );

  if (this.options.transitLayer) {
    const tL = new this.googleMaps.TransitLayer();
    tL.setMap(this.map);
  }
};

MapsAPI.prototype.addMarker = _addMarker;
MapsAPI.prototype.removeMarker = _removeMarker;
MapsAPI.prototype.isMarkerDefined = _isMarkerDefined;
MapsAPI.prototype.removeAllMarkers = _removeAllMarkers;
MapsAPI.prototype.changeMarkerIcon = _changeMarkerIcon;
MapsAPI.prototype.changeMarkerLabel = _changeMarkerLabel;
MapsAPI.prototype.getMarkerLabel = _getMarkerLabel;
MapsAPI.prototype.changeMarkerZIndex = _changeMarkerZIndex;
MapsAPI.prototype.setMarkerBounceAnimation = _setMarkerBounceAnimation;
MapsAPI.prototype.replaceMarkerListener = _replaceMarkerListener;
MapsAPI.prototype.clearMarkerListeners = _clearMarkerListeners;
MapsAPI.prototype.addMapListener = _addMapListener;
MapsAPI.prototype.removeMapListeners = removeMapListeners;
MapsAPI.prototype.addCircle = _addCircle;
MapsAPI.prototype.removeCircle = _removeCircle;
MapsAPI.prototype.setCenter = _setCenter;
MapsAPI.prototype.fitBoundsToMarkers = _fitBoundsToMarkers;
MapsAPI.prototype.fitBoundsToCoords = _fitBoundsToCoords;
MapsAPI.prototype.increaseZoom = _increaseZoom;
MapsAPI.prototype.setZoom = _setZoom;
MapsAPI.prototype.getBounds = _getBounds;
MapsAPI.prototype.coordsInBounds = _coordsInBounds;
MapsAPI.coordsInGivenBounds = _coordsInGivenBounds;

function _addMarker(markerId, opts) {
  if (this.markers[markerId]) {
    this.removeMarker(markerId);
  }

  var markerOpts = {
    position: {
      lat: parseFloat(opts.lat),
      lng: parseFloat(opts.lng)
    },
    map: this.map,
    icon: opts.icon,
    label: opts.label
  };

  if (opts.zIndex) {
    markerOpts.zIndex = opts.zIndex;
  }

  this.markers[markerId] = new this.googleMaps.Marker(markerOpts);
}

function _removeMarker(markerId) {
  if (this.markers[markerId]) {
    google.maps.event.clearInstanceListeners(this.markers[markerId]);
    this.markers[markerId].setMap(null);
    this.markers[markerId] = null;
  }
}

function _isMarkerDefined(markerId) {
  return this.markers[markerId] ? true : false;
}

function _removeAllMarkers() {
  for (var markerId in this.markers) {
    if (this.markers.hasOwnProperty(markerId)) {
      this.removeMarker(markerId);
    }
  }
}

function _changeMarkerIcon(markerId, iconPath) {
  if (this.markers[markerId]) {
    this.markers[markerId].setIcon(iconPath);
  }
}

function _changeMarkerLabel(markerId, label) {
  if (this.markers[markerId]) {
    this.markers[markerId].setLabel(label);
  }
}

function _getMarkerLabel(markerId) {
  if (this.markers[markerId]) {
    return this.markers[markerId].getLabel();
  }

  return null;
}

function _changeMarkerZIndex(markerId, zIndex) {
  if (this.markers[markerId]) {
    this.markers[markerId].setZIndex(zIndex);
  }
}

function _setMarkerBounceAnimation(markerId, timeout) {
  if (this.markers[markerId]) {
    this.markers[markerId].setAnimation(this.googleMaps.Animation.BOUNCE);

    if (timeout) {
      var _self = this;
      setTimeout(function() {
        if (_self.markers[markerId]) {
          _self.markers[markerId].setAnimation(null);
        }
      }, timeout);
    }
  }
}

function _replaceMarkerListener(markerId, eventName, callback) {
  if (this.markers[markerId]) {
    this.googleMaps.event.clearListeners(this.markers[markerId], eventName);
    this.googleMaps.event.addListener(
      this.markers[markerId],
      eventName,
      callback
    );
  }
}

function _clearMarkerListeners(markerId, eventName) {
  if (this.markers[markerId]) {
    this.googleMaps.event.clearListeners(this.markers[markerId], eventName);
  }
}

function _addMapListener(eventName, callback) {
  this.map.addListener(eventName, callback);
}

function removeMapListeners() {
  this.googleMaps.event.clearInstanceListeners(this.map);
}

function _addCircle(circleId, opts) {
  if (this.circles[circleId]) {
    this.removeCircle(circleId);
  }

  this.circles[circleId] = new this.googleMaps.Circle({
    strokeColor: opts.color,
    strokeOpacity: 0.4,
    strokeWeight: 1,
    fillColor: opts.color,
    fillOpacity: 0.15,
    map: this.map,
    center: {
      lat: parseFloat(opts.lat),
      lng: parseFloat(opts.lng)
    },
    radius: opts.radius
  });
}

function _removeCircle(circleId) {
  if (this.circles[circleId]) {
    this.circles[circleId].setMap(null);
    this.circles[circleId] = null;
  }
}

function _setCenter(opts) {
  this.map.setCenter({
    lat: parseFloat(opts.lat),
    lng: parseFloat(opts.lng)
  });
}

function _fitBoundsToMarkers() {
  var bounds = new this.googleMaps.LatLngBounds();
  _.each(this.markers, function(marker) {
    bounds.extend(marker.getPosition());
  });
  this.map.fitBounds(bounds);
}

function _fitBoundsToCoords(markersCoords) {
  var bounds = new this.googleMaps.LatLngBounds();
  if (markersCoords) {
    _.each(markersCoords, coords => {
      if (coords.lat && coords.lng) {
        bounds.extend(new this.googleMaps.LatLng(coords.lat, coords.lng));
      }
    });
  }
  this.map.fitBounds(bounds);
}

function _increaseZoom() {
  var currentZoom = this.map.getZoom();
  this.map.setZoom(currentZoom + 1);
}

function _setZoom(zoomValue) {
  this.map.setZoom(zoomValue);
}

function _getBounds() {
  var bounds = this.map.getBounds();

  return bounds;
}

function _coordsInBounds(coords, mapPadding) {
  var bounds = this.map.getBounds();
  var latlng = new this.googleMaps.LatLng(coords.lat, coords.lng);

  if (bounds && bounds.contains(latlng)) {
    if (!mapPadding) {
      return true;
    }

    var mapDiv = document.getElementById(this.mapId);
    var mapWidth = mapDiv.offsetWidth;
    var mapHeight = mapDiv.offsetHeight;

    var scale = Math.pow(2, this.map.getZoom());

    var projection = this.map.getProjection();
    var coordsPoint = projection.fromLatLngToPoint(latlng);
    var norhtWestPoint = projection.fromLatLngToPoint(
      new google.maps.LatLng(
        bounds.getNorthEast().lat(),
        bounds.getSouthWest().lng()
      )
    );

    var xOffset = Math.floor((coordsPoint.x - norhtWestPoint.x) * scale);
    var yOffset = Math.floor((coordsPoint.y - norhtWestPoint.y) * scale);

    var inXLimits = xOffset - mapPadding > 0 && xOffset + mapPadding < mapWidth;
    var inYLimits =
      yOffset - mapPadding > 0 && yOffset + mapPadding < mapHeight;
    if (inXLimits && inYLimits) {
      return true;
    }
  }

  return false;
}

function _coordsInGivenBounds(coords, boundsNeSw) {
  var bounds = new window.google.maps.LatLngBounds(
    boundsNeSw.sw,
    boundsNeSw.ne
  );
  var latlng = new window.google.maps.LatLng(coords.lat, coords.lng);

  var inBounds = false;
  if (bounds && latlng && bounds.contains(latlng)) {
    inBounds = true;
  }

  return inBounds;
}

export function getMapTypeOptions() {
  return {
    mapTypeIds: ['roadmap', 'satellite', 'hybrid', 'terrain'],
    style: window.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
    position: window.google.maps.ControlPosition.LEFT_BOTTOM
  };
}

export function getZoomOptions() {
  return {
    position: window.google.maps.ControlPosition.RIGHT_BOTTOM
  };
}

export default MapsAPI;
